module.exports = __webpack_public_path__ + "img/ic_intro.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/ic_intro.png
// module id = 745
// module chunks = 0